import { render } from "./PeriodFilter.vue?vue&type=template&id=5a1e5842&scoped=true"
import script from "./PeriodFilter.vue?vue&type=script&lang=js"
export * from "./PeriodFilter.vue?vue&type=script&lang=js"

import "./PeriodFilter.vue?vue&type=style&index=0&id=5a1e5842&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a1e5842"]])

export default __exports__